import { useState } from "react";
import { Modal, Show } from "shared/components";
import { FirstStep } from "views/settings-integration/components/AddIntegrationModal/FirstStep";
import { Header } from "views/settings-integration/components/AddIntegrationModal/Header";
import { SecondStep } from "views/settings-integration/components/AddIntegrationModal/SecondStep";
import { Step } from "views/settings-integration/components/AddIntegrationModal/types";

interface AddIntegrationModalProps {
  opened: boolean;
  onClose: () => void;
}

export const AddIntegrationModal = ({
  opened,
  onClose
}: AddIntegrationModalProps) => {
  const [selectedIntegration, setSelectedIntegration] = useState("");
  const [currentStep, setCurrentStep] = useState<Step>(Step.FIRST);

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      panelClassName="max-w-[480px] w-full flex flex-col p-6 shadow-xl"
    >
      <Header currentStep={currentStep} />

      <Show if={currentStep === Step.FIRST}>
        <FirstStep
          selectedIntegration={selectedIntegration}
          setSelectedIntegration={setSelectedIntegration}
          setCurrentStep={setCurrentStep}
        />
      </Show>

      <Show if={currentStep === Step.SECOND}>
        <SecondStep
          setCurrentStep={setCurrentStep}
          closeModal={onClose}
          selectedIntegration={selectedIntegration}
        />
      </Show>
    </Modal>
  );
};
